mutation PaymentUpdate($input: PaymentUpdateInput!) {
  paymentUpdate(input: $input) {
    payment {
      id
      _isTransactionPayment
      _requiredApprovalDocuments
      payCycleId
      vendorId
      vendorReference
      memo
      paymentReference
      paidDate
      payCycle {
        description
        isDraft
      }
      _baseCurrencyAmount
      paidAmount
      _invoiceTotal
      rowSecurityId
      _isUpdatable
      _isProtected
      _rowTimestamp
      currency {
        id
        isoCode
        name
      }
      invoicePayments {
        nodes {
          id
          _isTransactionPayment
          invoice {
            id
            description
            invoiceNumber
            vendorReference
            transactionType {
              id
              transactionType
              isDocumentSigningPayment
            }
            invoiceDate
            controlTotalAmount
          }
          _rowTimestamp
          _isUpdatable
          _isDeletable
        }
        aggregates {
          sum {
            appliedAmount
          }
        }
      }
    }
  }
}
